import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconErrorTriangle from 'components/icons/IconErrorTriangle';
import IconInfoNew from 'components/icons/IconInfoNew';
import { colorRedDark, colorGrayOverlay } from 'styles/layout/colors';
const PDPAlertBarIcon = t0 => {
  const $ = _c(2);
  const {
    type: t1
  } = t0;
  const type = t1 === undefined ? "info" : t1;
  if (type === "error") {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <IconErrorTriangle color={colorRedDark} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconInfoNew color={colorGrayOverlay} width={21} height={21} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
PDPAlertBarIcon.propTypes = {
  type: PropTypes.oneOf(['info', 'error'])
};
export default PDPAlertBarIcon;